exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".multiPartAnswerDisplay.emphasizeInputs .inputText{border-bottom:2px solid #bbb;padding:.1rem .3em;margin-right:.2em}.multiPartAnswerDisplay.emphasizeStarters .starter{border:1px solid #ddd;border-radius:5px;padding:.1rem .3em;color:#888}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/writing/answers/multi_part_answer_display.scss
// module id = 1505
// module chunks = 0